// extracted by mini-css-extract-plugin
export default {"food":"FoodList_food__DB6jg","food-appear":"FoodList_food-appear__-aBV-"};